import { ChatRoomInfoUserComponent } from './chat-room-info-user.component';

export default angular
  .module('sfMobile.components.chat-room-info-user', [
    'sfMobile.components.content',
  ])
  .component('sfChatRoomInfoUser', ChatRoomInfoUserComponent).name;
